import * as v from 'valibot'

import { QuoteTypeSchema } from './volume-quotes.js'

export const QueryParamsSchema = v.object({
  search: v.optional(v.string()),
  limit: v.optional(
    v.pipe(
      v.string(),
      v.transform(Number),
      v.integer(),
      v.minValue(1),
      v.maxValue(500),
    ),
    '50',
  ),
  accountId: v.optional(v.string()),
  cursor: v.optional(v.string()),
})

export type QueryParams = v.InferOutput<typeof QueryParamsSchema>

export const TracesQuerySchema = v.object({
  targetId: v.optional(
    v.pipe(
      v.union([v.string(), v.array(v.string())]),
      v.transform(val => (typeof val === 'string' ? [val] : val)),
    ),
  ),
  requestId: v.optional(v.string()),
  traceId: v.optional(v.string()),
  filter: v.optional(v.pipe(v.string(), v.trim(), v.maxLength(2000))),
  status: v.optional(v.picklist(['error', 'success'])),
  scac: v.optional(v.pipe(v.string(), v.length(4), v.toLowerCase())),
  includeBodies: v.optional(
    v.pipe(
      v.picklist(['true', 'false']),
      v.transform(val => val === 'true'),
    ),
    'true',
  ),
  limit: v.optional(
    v.pipe(
      v.string(),
      v.transform(Number),
      v.integer(),
      v.minValue(1),
      v.maxValue(500),
    ),
    '50',
  ),
  service: v.optional(v.string()),
  cursor: v.optional(v.string()),
  startDate: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  endDate: v.optional(v.pipe(v.string(), v.isoTimestamp())),
})

export type TracesQuery = v.InferOutput<typeof TracesQuerySchema>

export const RequestLogsQuerySchema = v.object({
  externalId: v.optional(v.string()),
  type: v.optional(v.string()),
  status: v.optional(v.string()),
  scac: v.optional(v.string()),
  requestId: v.optional(v.string()),
  trackingNumber: v.optional(v.string()),
  startDate: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  endDate: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  limit: v.optional(
    v.pipe(
      v.string(),
      v.transform(Number),
      v.integer(),
      v.minValue(1),
      v.maxValue(500),
    ),
    '50',
  ),
  cursor: v.optional(v.string()),
  errorType: v.optional(v.string()),
  quoteType: v.optional(QuoteTypeSchema),
})

export type RequestLogsQuery = v.InferOutput<typeof RequestLogsQuerySchema>

export interface AdminListResponse<T> {
  items: T[]
  nextCursor?: string
  prevCursor?: string
  total?: number
}

export interface DateRangeFilter {
  from?: string
  to?: string
}

export interface BaseQueryParams {
  search?: string
  limit?: number
  cursor?: string
}

export type GCPLog<T = any> = {
  id: string
  timestamp: string
  trace: string
  message: string
  data: T
}

export const UnmappedErrorsQuerySchema = v.object({
  limit: v.optional(
    v.pipe(
      v.string(),
      v.transform(Number),
      v.integer(),
      v.minValue(1),
      v.maxValue(500),
    ),
    '50',
  ),
  cursor: v.optional(v.string()),
  scac: v.optional(v.string()),
  category: v.optional(v.picklist(['ebol', 'tender'])),
  startDate: v.optional(v.pipe(v.string(), v.isoTimestamp())),
  endDate: v.optional(v.pipe(v.string(), v.isoTimestamp())),
})

export type UnmappedErrorsQuery = v.InferOutput<
  typeof UnmappedErrorsQuerySchema
>
